import { Component, componentMixin } from '@resn/gozer-core/component';
import ThreeObjectMixin from '@resn/gozer-core-mixins/three-object';
import { COLORS } from 'core/constants';
import { lerp } from '@resn/gozer-math';
import * as THREE from 'three';
import gsap from 'gsap';
import { isMobile } from '@resn/gozer-env';

import getStore from 'core/store';
import HeroTopArrow from 'component/sections/xp1/common/top-arrow';
const store = getStore();

// import './index.scss';

// const template = ({ options }) => html`
//     <div class="bgArrows">
//         <div data-ui="arrow1" class="js-arrow  bgArrows__arrow1"></div>
//         <div data-ui="arrow2" class="js-arrow  bgArrows__arrow2"></div>
//         <div data-ui="arrow3" class="js-arrow  bgArrows__arrow3"></div>
//     </div>
// `;

// @componentMixin(DomComponentMixin)
// @componentMixin(DomComponentMixin)

@componentMixin(ThreeObjectMixin)
class HomeBgArrows extends Component {
    props = {
        active: false,
    };

    options = {
        // template,
    };

    tweens = {};

    async onSetup() {
        await this.setupArrows();
    }

    async setupArrows() {
        const total = 3;
        const array = new Array(total).fill();

        this.arrows = await Promise.all(
            array.map((a, index) => {
                const obj = new THREE.Object3D();
                obj.scale.x = 0.85;
                this.object.add(obj);

                const pct = index / total;
                // const xOffset = lerp(pct, 0, -0.78);
                const xOffset = isMobile ? lerp(pct, 0, -0.6) : lerp(pct, 0, -0.78);
                const thickness = isMobile ? lerp(pct, 0.08, 0.04) : lerp(pct, 0.1, 0.06);
                // const thickness = 0.12;

                return new HeroTopArrow().setup({
                    options: {
                        index,
                        addTo: obj,
                        layer: this.options.layer,
                        color1: '#C7DEFF',
                        // color2: COLORS.LIGHT_BLUE,
                        color2: COLORS.LIGHT_BLUE,
                        gradRotation: Math.PI * -0.25,
                        useMask: true,
                    },
                    props: {
                        // s: () => 500,
                        s: () =>
                            store.state.mobile ? store.state.viewport.width * 1.8 : store.state.viewport.height * 1.8,
                        rZ: Math.PI * -0.25,

                        xBase: (props) => props.s * xOffset,
                        xTween: 0,
                        pX: (props) => props.xBase + props.xTween,

                        thicknessBase: thickness,
                        thicknessTween: 0,
                        thickness: (props) => props.thicknessBase * props.thicknessTween,

                        v: (props) => props.thickness !== 0,
                    },
                });
            }),
        );

        this.arrows.forEach((arrow) => {
            arrow.tweens = {
                inPr: 0,
                outPr: 0,
                linearPr: 0,
            };
        });
    }

    onActive() {
        const { route } = store.state;
        const delay = route.first ? 0.9 : 0;
        this.activeDelay = gsap.delayedCall(delay, () => {
            this.show();
        });
    }

    show() {
        const stagger = 0.3;
        const duration = 2.7;
        const showDelay = duration + stagger * this.arrows.length - 0.5;

        this.arrows.forEach((arrow, i) => {
            const delay = i * stagger;
            gsap.killTweensOf(arrow.tweens);
            gsap.fromTo(arrow.tweens, { inPr: 0, outPr: 0 }, { inPr: 1, duration, delay: delay, ease: 'expo.out' });
            gsap.fromTo(arrow.tweens, { linearPr: 0 }, { linearPr: 1, duration: 10, ease: 'none' });
        });

        this.showCompleteDelay = gsap.delayedCall(showDelay, () => {
            if (this.props.active) this.hide();
        });
    }

    hide() {
        const duration = 1.2;
        const stagger = 0.2;
        const hideDelay = duration + stagger * this.arrows.length;

        this.arrows.forEach((arrow, i) => {
            const delay = i * stagger;
            gsap.to(arrow.tweens, { outPr: 1, duration, delay, ease: 'power2.in' });
        });

        this.hideCompleteDelay = gsap.delayedCall(hideDelay, () => {
            if (this.props.active) this.show();
        });
    }

    update() {
        const { width, height } = store.state.viewport;

        this.arrows.forEach((arrow, i) => {
            const { s } = arrow.props;
            const pct = i / this.arrows.length;
            const xIn = lerp(pct, s * -0.6, 0);
            const xOut = lerp(pct, s * 0.15, s * 0.3);
            const xAmbient = lerp(arrow.tweens.linearPr, 0, s * 0.25);

            // const xIn = lerp(pct, height * -1.2, height * -0.4);
            // const xOut = lerp(pct, height * 0.3, height * 1.2);
            // const xAmbient = lerp(arrow.tweens.linearPr, height * -0.25, height * 0.25);

            const x = lerp(arrow.tweens.inPr, xIn, 0) + lerp(arrow.tweens.outPr, 0, xOut) + xAmbient;
            const thickness = lerp(arrow.tweens.inPr, 0.7, 1) * (1 - arrow.tweens.outPr);

            arrow.props.xTween = x;
            arrow.props.thicknessTween = thickness;
            arrow.props.alpha = arrow.tweens.inPr * (1 - arrow.tweens.outPr);
        });
    }

    onDestroy() {
        if (this.activeDelay) this.activeDelay.kill();
        if (this.showCompleteDelay) this.showCompleteDelay.kill();
        if (this.hideCompleteDelay) this.hideCompleteDelay.kill();

        this.arrows.forEach((arrow) => {
            arrow.destroy();
        });
    }
}

export default HomeBgArrows;
